import o from "debug";
const t = (e) => o("@sp").extend(e), r = t("sp-ui-lib");
export {
  t as getLogger,
  r as spUiLibLogger
};
